import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const InCredLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. What is the highest amount that may be borrowed with an InCred education loan?",
            content: "With InCred’s education loan offerings, borrowers may obtain loans of up to INR 60 Lakh without the necessity of collateral. This means that individuals may pursue their educational goals without the burden of providing assets as security. Moreover, for those who can collateral, InCred extends the loan limit to INR 80 Lakh, providing even greater financial assistance."
        },
        {
            title: "2. What is the interest rate on the InCred education loan?",
            content: "Depending on the institution or university applied to, it usually ranges from 12.5 to 13.5% for other nations and from 11.85% to 13.25% for the US."
        },
        {
            title: "3. What is the duration of the repayment period for an Incred education loan?",
            content: "The InCred education loan offers a repayment tenure of up to 15 years."
        },
        {
            title: "4. Do Incred education loans require any margin money to be paid?",
            content: "Incred provides complete coverage for all of a student’s expenses."
        }, {
            title: "5. Are there any tax advantages associated with education loans provided by InCred?",
            content: "There are no tax benefits associated with education loans obtained from NBFCs like Incred."
        }, {
            title: "6. Does Incred education loans have a prepayment penalty?",
            content: "There are no restrictions on making prepayments at any time in Incred."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"InCred Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"InCred Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">InCred Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">In India, InCred stands out as a prominent digital lending NBFC, providing a diverse array of loans such as education loans tailored for students aspiring to pursue studies overseas. The organization wants to make it easy and accessible for students from all backgrounds to apply for an education loan.
                                <br /><br />
                                One of the main benefits of an InCred abroad education loan is that it may be utilized to cater to a variety of costs related to studying overseas, including living expenses, transportation costs, tuition, and other additional expenses. InCred provides loans up to INR 60 Lakh, with the actual loan amount being subject to variation based on factors such as the institution, course, and country of study.</p>
                            <h5 className="about-head">Overview of InCred Education Loan</h5>

                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            11.85% - 13.25%
                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">
                                            Up to INR 60 Lakh

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            1-2%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing time
                                        </td>

                                        <td className="">
                                            7-10 days</td>

                                    </tr>
                                    <tr>
                                        <td className="">

                                            Margin money</td>
                                        <td className="">

                                            Nil
                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Moratorium Period</td>
                                        <td>Course duration + 1-year</td></tr>
                                    <tr>
                                        <td>Repayment tenure</td>
                                        <td>15 years</td>
                                    </tr>

                                </tbody>
                            </table>

                            <h5 className="about-head">InCred Education Loan Eligibility Criteria</h5>
                            <h5 className="about-head">Age</h5>

                            <p className="loan-elegibility-des">At the time of application, the candidate must be an Indian citizen and be at least eighteen years old. The student needs to have received admission into a reputable university.</p>


                            <h5 className="about-head">Academic Performance</h5>
                            <p className="loan-elegibility-des">To qualify for an education loan, the candidate has to fulfill InCred’s minimal academic standards and have a consistently excellent academic record. Furthermore, the student has to have passed needed tests like the GRE, TOEFL, or IELTS. It’s crucial to remember that having a strong GRE score will significantly boost your chances of getting approved for a loan while applying in the US.</p>

                            <h5 className="about-head">Co-applicant</h5>
                            <p className="loan-elegibility-des">The borrower needs a co-applicant, who may be their mother, father, sister, brother, spouse, a relative from their mother’s or father’s side, or a legal guardian, to apply for a loan. A steady source of income and a clean credit history are prerequisites for the co-applicant.</p>
                            <h5 className="about-head">Course and Country of Study</h5>
                            <p className="loan-elegibility-des">This program will include standard graduate, postgraduate, diploma, certificate, and Ph.D. courses in any field provided by international institutes and universities in the United States, the United Kingdom, Canada, Australia, New Zealand, France, Germany, and Ireland.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">InCred Education Loan for US</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>GRE  &gt;=310	</th>
                                        <th>GRE 300 - &lt; 310	</th>
                                        <th>GRE 285 - &lt; 299</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Rate of interest</td>
                                        <td>12.25 - 12.75%</td>
                                        <td>12.75% - 13%</td>
                                        <td>13-14%</td>
                                    </tr>
                                    <tr>
                                        <td>Loan amount</td>
                                        <td>Up to INR 60 Lakh</td>
                                        <td>Up to INR 40 Lakh</td>
                                        <td>Up to INR 35 Lakh</td>
                                    </tr>
                                    <tr>
                                        <td>Co-applicant minimum income</td>
                                        <td>INR 30K</td>
                                        <td>INR 35K</td>
                                        <td>INR 35K</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly installment during the course</td>
                                        <td>Partial simple interest</td>
                                        <td>Partial simple interest</td>
                                        <td> simple interest</td>
                                    </tr>
                                    <tr>
                                        <td>Processing fees</td>
                                        <td>1%</td>
                                        <td>1%</td>
                                        <td>1%</td>
                                    </tr>

                                </tbody>
                            </table>

                            <h5 className="about-head">InCred Education Loans for Other Countries</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Australia / New Zealand		</th>
                                        <th>Canada</th>
                                        <th>UK</th>
                                        <th>Germany/Ireland/
                                            France/Italy</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>
                                            Rate of interest
                                        </td>
                                        <td>12.25 - 13%</td>
                                        <td>12 - 13%</td>
                                        <td>12.5 - 13.5%</td>
                                        <td>12.5 - 13.5%</td>
                                    </tr>
                                    <tr>
                                        <td>Loan amount</td>
                                        <td>INR 20 Lakh</td>
                                        <td>INR 35 Lakh</td>
                                        <td>INR 40 Lakh</td>
                                        <td>INR 20 Lakh</td>
                                    </tr>
                                    <tr>
                                        <td>Co-applicant minimum income</td>
                                        <td>INR 60K</td>
                                        <td>INR 35K</td>
                                        <td>INR 40K</td>
                                        <td>INR 40K</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly installment during the course</td>
                                        <td>Simple Interest</td>
                                        <td>Partial simple interest/simple interest</td>
                                        <td>Simple interest</td>
                                        <td>Simple interest</td>
                                    </tr>
                                    <tr>
                                        <td>Processing fees</td>
                                        <td>1 - 1.5%</td>
                                        <td>1%</td>
                                        <td>1 - 2%</td>
                                        <td>1 - 1.5%</td>
                                    </tr>

                                </tbody>
                            </table>


                            <h5 className="about-head">Documents Required for InCred Education Loan</h5>


                            <p className="loan-elegibility-des">Credere offers a personalized list of required documents for InCred student loans based on your profile, the profiles of your co-applicants, and any assets or property you want to put up as collateral.</p>


                            <h6 className="subhead mt-4">Applicant's Documents</h6>
                            <ol className="subhead-ul">
                                <li>Address proof: recent copy of water bill/electricity bill/telephone bill/ piped gas bill/ driving license/ Aadhaar card.</li>
                                <li>Education loan application form.</li>
                                <li>Identity proof: PAN/ Passport/ Driver’s License/ Voter ID card or government-issued identification document.</li>
                                <li>Passport.</li>
                                <li>Past academic record.
                                    <ol className="subhead-ul">
                                        <li>10th standard mark sheet</li>
                                        <li>12th standard mark sheet</li>
                                        <li>Undergraduate result (semester-wise)</li>
                                    </ol>
                                </li>

                                <li>Entrance exam results (e.g. GMAT, GRE, TOEFL, etc.)</li>
                                <li>Proof of admission: admission letter (A conditional admission letter is also applicable).</li>
                                <li>Statement of expenses.</li>
                            </ol>
                            <h6 className="subhead">Co-applicants Documents</h6>
                            <ol className="subhead-ul">
                                <li><b>Identity proof : </b>Passport/ PAN/ Driver’s license/ Voter ID card or government-issued identification document.</li>
                                <li><b>Address :</b> recent copy of electricity bill/water bill/ telephone bill/ piped gas bill or copy of passport/ Aadhaar card/driving license.</li>
                                <li>Bank account statement of the co-borrower/guarantor, for the last 6 months (in case of takeover of education loan).</li>
                                <li>2 passport-size photographs.</li>
                            </ol>
                            <h5 className="about-head">Income Proof for Salaried Co-applicant/Guarantor</h5>
                            <ol className="subhead-ul">
                                <li>Statement of the salary account for the previous six months.</li>
                                <li>Copy of Form 16 of the last 2 years or a copy</li>
                                <li>Earnings records (Salary slips) for the last three months</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                            </ol>
                            <h5 className="about-head">Income Proof for Self-employed Co-applicant/ Guarantor</h5>
                            <ol className="subhead-ul">
                                <li>TDS certificate (Form 16A, if applicable)</li>
                                <li>Business address proof</li>
                                <li>Last 2 years IT returns (If IT Payee)</li>
                                <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                                <li>Certificate of qualification (for C.A./ doctor and other professionals)</li>
                                <li>Bank account statement for the last 6 months</li>
                            </ol>

                            <h5 className="about-head">Ways to Get in Touch with InCred About a Student Loan?</h5>
                            <p className="loan-elegibility-des">You may utilize one of these methods to get in touch with InCred for services about student loans:</p>
                            <p className="loan-elegibility-des"><b>Email</b></p>
                            <p className="loan-elegibility-des">Send a thorough email with details about your profile to visugrievance@incred.com. After reviewing your email, their staff will reply accordingly.</p>
                            <p className="loan-elegibility-des"><b>Online Application Form</b></p>
                            <p className="loan-elegibility-des">Go to the “Contact Us” section of the InCred website (www.incred.com/offices.html). You may continue with the process by completing the online application form, after which they will review your profile.</p>
                            <p className="loan-elegibility-des"><b>Branch visits</b></p>
                            <p className="loan-elegibility-des">Go to the InCred branch that is closest to you in your town or city. Assistance with education loans, the application procedure, necessary paperwork, and other relevant details may be received by the branch staff members. The head office of InCred is located in Mumbai, and the company also has offices in Ajmer, Ahmedabad, Alwar, Andheri, Bhilwara, Bangalore, Chennai, Coimbatore, Delhi, Hyderabad, Hubli, Jaipur, Jodhpur, Kolkata, Karimnagar, Kuppam, Mdhurai, and Pune, among other Indian cities.
                                <br /><br />
                                Credere is an education financing platform that specializes in assisting students in getting funding for their higher education abroad. If you’re interested in applying for a study abroad loan through InCred but want to avoid the inconvenience of visiting physical branches and navigating complex application forms, you can apply through Credere.
                                <br /><br />
                                After you fulfill the eligibility conditions, one of our professional counselors will carefully review your profile and recommend the lenders who would best fit your special loan requirements. Our counselors will help and assist you along the loan process, and they are always available to respond to queries or deal with any challenges you might encounter. </p>

                            <h5 className="about-head">Advantages of Obtaining your InCred Education Abroad Loan via Credere</h5>
                            <p className="loan-elegibility-des"><b>Best Loan Assurance</b></p>
                            <p className="loan-elegibility-des">Credere consistently maintains its promise to give you the best education loan deal on the market. Our objective is to get you the best possible deal. If you find a better deal, we will pay the difference in interest rates for the whole term of the educational loan.</p>
                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>
                            <p className="loan-elegibility-des">Credere collaborates closely with multiple InCred departments to speed up the loan approval process, which is normally finished in 5-7 days. Every year, dozens of students entrust Credere with their requests for loans for overseas study because of its reliability. In comparison, the loan processing period would typically take ten to twelve days if a student applied directly to the NBFC.</p>
                            <p className="loan-elegibility-des"><b>Completely Free Services</b></p>
                            <p className="loan-elegibility-des">Applicants receive Credere’s services entirely free of cost; there are no further costs. </p>
                            <p className="loan-elegibility-des"><b>Comparison of Lenders</b></p>
                            <p className="loan-elegibility-des">Credere’s knowledgeable education loan advisers evaluate several lenders’ loan offerings to determine which one best meets your needs. This involves comparing various lenders’ interest rates, loan amounts, periods of repayment, fees, and other factors.</p>
                            <p className="loan-elegibility-des"><b>Online Document Submission</b></p>
                            <p className="loan-elegibility-des">You may apply for a loan online and get it authorized from the comfort of your home with the Credere online document upload option. Document submission does not need a personal visit to the NBFC! Additionally, to keep you informed about the periodic updates, we will send you alerts.</p>
                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default InCredLendingPartner;